var TestemunhalSearch = function () {

	this.article = function (item) {

		var html = "";
	
		html += '<div class="artigo-testemunhal">';
		html += '<img src="'+ item.Image + '">';
		html += '<div class="perfil">';
		html += '<h4 class="nome">'+ item.Name + '</h4>';
		
		html += '<span>'+ item.Tags + '</span>';
	
		html += '</div>';		
		html += '<p class="data">'+ item.Date + '</p>';
		html += '<p class="desc">' + item.ShortDescription + '</p>'
		html += '<a href="' + item.Url + '">Ler Mais</a>';
		html += '</div>';
		
	
		return html;
	}

	this.init = function () {
		var obj = this;
		$('.btn-search').click(function(e){
			e.preventDefault();

			$('.loader').show();
			$('.btn-more-testemunhal').show();

			var Limiter = 5; //$(this).data("limiter");
			var TotalAmount = $(".artigo-testemunhal").length;
			var query = $('[data-component="testemunhal-search"]').find('#busca').val();

			$.ajax({
				type: "POST",
				url: "/umbraco/surface/Testemunhal/Search",
				data: JSON.stringify({"Query": query, "Limiter": Limiter , "TotalAmount": TotalAmount}),
				dataType: "json",
				async: true,
				contentType: "application/json; charset=utf-8",
				success: function success(response) {
					
					var html = '';
					if(response){
						
						$('#artigo-testemunhal').html('');
						if(response.testimonialListTotalAmount == 0){
							$('.btn-more-testemunhal').hide();
							$('[data-component="testemunhal-search"]').append('<h5>Nenhum resultado encontrado.</h5>');
						}else{
							for (var i = 0; i < response.testimonials.length; i++) {
								html += obj.article(response.testimonials[i]);
							}

							$('[data-component="testemunhal-search"]').parent().find("#artigo-testemunhal").append(html);
							
							TotalAmount = $(".artigo-testemunhal").length; 
							if(TotalAmount >= response.testimonialListTotalAmount){
								$('.btn-more-testemunhal').hide();
							}else{
								$('.btn-more-testemunhal').show();
							}
						}

					}
					else{
						
					}
					
				},
				error: function error(e) {
					
				},
				complete: function () {
					$('.loader').hide();
				}
			});
		
		});
	}

	return this.init();
	
}